import { createHashHistory } from 'history';

export const history = createHashHistory({forceRefresh:true});

export default history;